import { Button } from '@hi/react-material'
import { FormControlLabel, RadioGroup, StepLabel } from '@material-ui/core'
import { styled } from '@mui/material'

export const Header = styled('div')({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export const SCStepLabel = styled(StepLabel)({
  '.MuiStepLabel-label': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  '.MuiStepIcon-text': {
    fill: 'white',
  },
})

export const SCRadioGroup = styled(RadioGroup)({
  marginLeft: '56px',
  marginTop: '16px',

  '.Mui-checked': {
    color: '#00AEEF',
  },
})

export const RadioLabel = styled(FormControlLabel)({
  '.MuiFormControlLabel-label': {
    display: 'flex',
    flexDirection: 'column',
    color: '#212121',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%' /* 24px */,

    '> span': {
      color: '#666',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '166%' /* 19.92px */,
      letterSpacing: '0.4px',
    },
  },
})

export const NewEventSection = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  marginLeft: '56px',
  marginTop: '12px',
})

export const NewEventBtn = styled(Button)({
  color: '#00AEEF !important',
})
